module.exports = "//static.hsappstatic.net/codemirror/static-5.25/codemirror.css"